import { render, staticRenderFns } from "./routeVueComponent.vue?vue&type=template&id=74897fc8&scoped=true&"
import script from "./routeVueComponent.vue?vue&type=script&lang=js&"
export * from "./routeVueComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74897fc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74897fc8')) {
      api.createRecord('74897fc8', component.options)
    } else {
      api.reload('74897fc8', component.options)
    }
    module.hot.accept("./routeVueComponent.vue?vue&type=template&id=74897fc8&scoped=true&", function () {
      api.rerender('74897fc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/vueSample/routeVueComponent.vue"
export default component.exports